<template>
<div class="modal" ref="modal" id="settings" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content full-screen-settings">
      <div class="modal-header p-2">
        <h5 class="modal-title mt-2 ml-2">{{$t('Share')}}</h5>
        <button type="button" class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close">
          <span aria-hidden="true"><h2><cancel-icon class="close-icon" style="height: 35px !important;
    width: 35px !important;
    color: #fff;"></cancel-icon></h2></span>
        </button>
      </div>
      <div class="modal-body p-0">
          <nav class="navbar navbar-expand-lg p-0" style="height:71px">
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav w-100 top-nav-bar" style="height: 70px;">
                <a
                    class="nav-item share-top-nav nav-link w-50"
                    v-for="panel in getRegisteredShareTopNavMenus()"
                    v-on:click="getEventHandler('onClick', panel.onEvents, panel)"
                    :key="panel.label"
                    :class="(activeIndex === panel.label)?'active':'inactive'"
                    style="width: 20% !important;line-height: 55px;display: flex;justify-content: center;"
                    >
                    <span v-html="panel.iconSvgCallback()" style="width: 20%;"></span>
                    <span style="font-size:20px">{{ panel.label }}</span><span class="sr-only">(current)</span></a
                >
                </div>
            </div>
            </nav>
            <div class="col-md-12 p-0" style="height: calc(100% - 80px);overflow:auto">
            <component
                :is="selectedComponent"
                v-bind="currentProperties"
                @closeWindow="close()"
                class="h-100"
            ></component>
            </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import ExternalSharePluginLoader from "./sharePluginLoader.vue"
import CancelIcon from "../core/InlineCancelField.vue";

export default {
  data() {
    return {
      selectedFilesDataFromBrowse:{},
      activeIndex: "",
      topNavList: [],
      selectedComponent: "external-import-export-plugin-loader",
      selectedPluginInfo: null,
      parentRouteInfo:{}
    };
  },
  components: {
    "external-share-plugin-loader":ExternalSharePluginLoader,
    "cancel-icon":CancelIcon
  },
  computed: {
    currentProperties() {
      if (this.selectedComponent == "external-share-plugin-loader") {
        if (this.selectedPluginInfo == undefined || this.selectedPluginInfo == null){
            return { pluginInfo:  this.getDefaultSelectedPluginInfo(), selectedFileInfo:this.selectedFilesDataFromBrowse};
        }else{
            return { pluginInfo: this.selectedPluginInfo , selectedFileInfo:this.selectedFilesDataFromBrowse};
        }
      } else {
        return {};
      }
    },
  },
  methods: {
    closeModalCompoent(){
      if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
        this.$router.push({
          name: this.parentRouteInfo.name,
          params:this.parentRouteInfo.params,
          query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
        })
      }else{
        this.$router.push({
          name: "explorer",
        })
      }
    },
    getDefaultSelectedPluginInfo(){
        let panel = this.getRegisteredShareTopNavMenus()[0];
        this.activeIndex = panel.label;
        return panel
    },
    changeComponent(comp, label) {
      (this.activeIndex = label), (this.selectedComponent = comp);
    },
    changeComponentToExternalPlugin(label) {
      this.changeComponent("external-share-plugin-loader", label);
    },
    getEventHandler(eventname, supportedEvents, pluginInfo) {
      this.selectedPluginInfo = null;
      if (pluginInfo) {
        this.selectedPluginInfo = Object.assign({}, pluginInfo);
        return this.changeComponentToExternalPlugin(pluginInfo.label);
      } else {
        let event = supportedEvents.filter(
          (eventInfo) => eventInfo.event_name == eventname
        );
        if (event.length != 0) {
          return event[0]["event_handler"]();
        }
      }
    },
    close() {
      this.closeModalCompoent();
    },
    ...mapGetters("registry", ["getRegisteredShareTopNavMenus"]),
  },
  mounted() {
    // this.setUpImportExportSettingsTopNav(this.topNavList);
  },
  created(){
    Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    Object.assign(this.selectedFilesDataFromBrowse, this.$route.params.selectedFilesDataFromBrowse)
    console.log("this.selectedFilesDataFromBrowse",this.selectedFilesDataFromBrowse)
    setTimeout(() => {
      let firstFile =  document.getElementsByClassName("share-top-nav")[0];
      firstFile.click();
    }, 200);
  }
};
</script>


<style scoped lang="scss">
$border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $icon-hover:#2c3339;

.modal{
      display:block;        
  }

.sidebar-menu{
  background: $secondary-background-color;
}
  .modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .modal-header .close {
    margin: -1rem -13px -1rem auto !important;
  }
  
  .modal-body{
    height: calc(100vh - 65px);
  }

  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background: $primary-background !important;
  }

  .modal-header,.modal-footer{
    height:65px;
    border: $secondary-border-color !important;
    background: $secondary-background-color;
}

.activeclass{
    background: $primary-background !important;
  h6{
    color: $active-blue !important;
    fill: $active-blue !important;
    position: relative;
    // inset-inline-end :4px;
  }
  svg{
    color: $active-blue !important;
    fill:$active-blue !important;
    }
}

.border{
    border: $border-color !important;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

.nav-item {
  color: $dull-text-color !important;
}

.inactive:hover{
  color:$text-color !important;
}
.active {
  // background: $primary-background !important;
  color:$active-blue  !important;
  border-bottom: 2px solid $active-blue ;
}
.top-nav-bar {
  background: $secondary-background-color;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
</style>